export default "__VITE_ASSET__CLqxsycw__"